export const PAYMENT_FAILED = 'failed';
export const SESSION_EXPIRED = 'session-expired';
export const UNKNOWN_ERROR = 'unknown';